import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/index';
import { HomeService } from '../_services/home.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
  i18n: any;
  forgotPwdLabelConfig: any = {};
  forgotPwdAuthenticatopmConfig: any = {};
  forgotPwdMsgConfig: any = {};
  resetPwdIsFailed = false;
  resetPwdSuccess = false;
  resetSuccesMsg: string;
  resetEmailSuccessMsg: string;
  resetEmailFailureMsg: string;
  model: any = {};
  forgotPwdTitle: string;
  emailAuthentic = false;
  columnType: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private homeService: HomeService) { }

  ngOnInit() {
    this.forgotPwdTitle = "Password Reset";
    this.homeService.sendMessage(true);
    this.homeService.getLoginConfig().subscribe(res => {
      this.forgotPwdLabelConfig = res.return_body.loginLabel;
      this.forgotPwdAuthenticatopmConfig = res.return_body.authenticationConfig;
      this.forgotPwdMsgConfig = res.return_body.loginMsg;
      if (this.forgotPwdLabelConfig.displayUserName) {
        this.emailAuthentic = true;
        this.columnType = this.forgotPwdAuthenticatopmConfig.resetPwdFindSimsUserBy;
      }
      else
        this.columnType = "email";
      console.log(this.forgotPwdLabelConfig);
    });
    if (sessionStorage.getItem('i18n')) {
      this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    setTimeout(() => {
      this.homeService.sendMessage(false);
    }, 500);
  }



  handleNavigation(pathValue) {
    if (pathValue) {
      this.router.navigate([this.router.url.split("/")[1], pathValue]);
    }
  }

  forgotPasswordReset() {
    this.authenticationService.forgotPwdReset(this.columnType, this.model.username, String(this.homeService.institutionId))
      .subscribe(
        data => {
          if (data.return_body != null) {
            this.resetPwdSuccess = true;
            this.resetSuccesMsg = this.i18n._value['shp.dbAuthenticate.passwordReset.success.content'];
            this.resetEmailSuccessMsg = this.i18n._value['shp.passwordReset.success.header'];
          }
          else {
            this.resetPwdIsFailed = true;
            this.resetEmailFailureMsg = this.forgotPwdMsgConfig.resetPwdErrorMsg;
          }
          this.homeService.sendMessage(false);
        },
        error => {
          this.resetPwdIsFailed = true;
          this.resetEmailFailureMsg = this.forgotPwdMsgConfig.resetPwdErrorMsg;
          this.homeService.sendMessage(false);

        });




  }

  closeAlert() {
    this.resetPwdIsFailed = false;
  }
}
